import { useSearchParams } from 'react-router-dom';
import { Signin } from './signin';
import { ForgotPassword } from './signin/forgotpassword';
import { Signup } from './signup/account';

export function AuthEntry() {
  const [searchParams] = useSearchParams();
  const view = searchParams.get('view');

  if (view === 'register') {
    document.title = 'Register to UrbanMetrix';
    return <Signup />;
  }

  if (view === 'forgot-password') {
    document.title = 'Forgot Your Password?';
    return <ForgotPassword />;
  }

  document.title = 'Welcome to UrbanMetrix';
  return <Signin />;
}
